import { signal } from "@preact/signals";

const makeMeta = () => {
    const title = signal("Marathon Engage");
    const prefix = signal("");

    return {
        title,
        prefix,
    };
};

export default makeMeta;
